import React, { useState } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { Card, Empty,Button } from 'antd';
import {useParentState} from 'utils';
const { Meta } = Card;

const ResponsiveGridLayout = WidthProvider(Responsive);



const MyResponsiveGrid = ({items:gridItems,layouts:_layouts,setLayouts:_setLayouts}) => {    
  
  const [layouts, setLayouts] = useParentState(_layouts,_setLayouts);
  const [mounted,setMounted]=React.useState(false);
  console.log("_layouts",_layouts);
  // React.useEffect(()=>{    
  //   const _initialLayouts = _layouts?_layouts:{lg:gridItems.map((o,i)=>({ i: o?.id ??i, x: 0, y: 0, w: 2, h: 2,"static":false }))};
  //   setLayouts(_initialLayouts)
  // },[_layouts,gridItems])
  
  const handleLayoutChange = (newLayout,newLayouts) => {    
    
    setLayouts(newLayouts);
  };
  // const handleStatic = (itemId)=>{
  //   const items=layouts?.xs ??[];
    
  //   const item = items.find(o=>o.i ==itemId);
  //   const otherItem = items.filter(o=>o.i !=itemId);
  //   const {"static":isStatic=true}=item||{};
  //   setLayouts({xs:[...otherItem,{...item,"static":!isStatic}]});
    
  // }
  
  React.useEffect(()=>{   
    setTimeout(()=>setMounted(true), 500); 
  },[])
  

  return (
    
      
      <ResponsiveGridLayout
        
        className="layout"
        layouts={layouts}
        isResizable={mounted}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 3, md: 2, sm: 2, xs: 1, xxs: 1 }}
        rowHeight={300}
        onLayoutChange={handleLayoutChange} // Handle layout changes
      >
        
        {
         gridItems.map((item,i)=>{          
          return (
            <div key={i}>
              {mounted&&
              <Card 
                title={item.title} 
                style={{ width: '100%', height: '100%' }}
                // extra={
                //   <Button
                //     icon={isStatic ? <LockOutlined />:<UnlockOutlined />}
                //     onClick={() => handleStatic(i)}
                //     type="link"
                //     shape="circle"
                //     size="small"
                //   />
                // }
                >
                {item.body()}
              </Card>
              }
            </div>
          )})
        }
      </ResponsiveGridLayout>
    
  );
};

export default MyResponsiveGrid;
